import React from 'react'
import { Header, TableComplete } from '@e3dc-react/shell/Elements/Table'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { nullsLast } from '@e3dc-react/shell/Libs/SortAlgorithms'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { QntmModel } from 'src/Libs/installation-details/models'
import List from '@e3dc-react/shell/Elements/List/List'

interface QntmTableProps {
  qntm: QntmModel[]
}

/**
 * Component that holds a table with all qntm of a storage
 */
const QntmTable: React.FC<QntmTableProps> = ({ qntm }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const showListView = useMediaQuery(theme.breakpoints.down('sm'))

  const QntmTableColumns: Header<QntmModel>[] = [
    {
      value: 'deviceName',
      label: t('common.serialnumber'),
      sortFunction: nullsLast((a: string, b: string) => a.localeCompare(b)),
      valueRender: value => value ?? '-',
    },
  ]

  if (showListView) {
    return (
      <Box sx={theme => ({ paddingBottom: theme.spacing(2) })}>
        <List
          data={qntm.map(item => ({
            primary: item.deviceName,
          }))}
          noDataText={t('system-details.components.qntm.no-data')}
        />
      </Box>
    )
  }

  return (
    <TableComplete
      header={QntmTableColumns}
      data={qntm ?? []}
      headerElevation={0}
      bodyElevation={0}
      footerElevation={0}
      coloredColumn
      disablePagination
      noDataText={t('system-details.components.qntm.no-data')}
    />
  )
}

export default QntmTable
